module.exports = __webpack_public_path__ + "img/pc_banner.cb8a128d.jpg";